export const REPORT_FORM_FIELD_IDS = {
  REPORT_NAME: 'report-name',
  CREATION_METHOD: 'creation-method',
  WORKSPACE_TEMPLATE_SELECT: 'workspace-template-select',
  WORKSPACE_TEMPLATE_SELECT_EMPTY: 'workspace-template-select-empty',
  FUTRLI_TEMPLATE_SELECT: 'futrli-template-select'
};
